import { formats as defaultFormats, type ImageFormat } from "./imageFormats";
import type { FormatResults } from "./imageTypes";

export const saveAs = (uri: string, filename: string) => {
  const link = document.createElement("a");
  link.href = uri;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

type ZipFiles = (files: Array<{ name: string; data: ArrayBuffer }>) => Promise<ArrayBuffer>;

const zipWithWorker: ZipFiles = async (files) => {
  const { zipInWorker } = await import("./workerClients");
  return zipInWorker(files);
};

interface DownloadResultsOptions {
  mime: string;
  results: FormatResults;
  formats?: ImageFormat[];
  zipFiles?: ZipFiles;
  save?: typeof saveAs;
  onError?: (error: unknown) => void;
}

export const downloadResultsForMime = async ({
  mime,
  results,
  formats = defaultFormats,
  zipFiles = zipWithWorker,
  save = saveAs,
  onError,
}: DownloadResultsOptions): Promise<boolean> => {
  const formatResults = results[mime];
  if (!formatResults || formatResults.length === 0) return false;

  if (formatResults.length === 1) {
    save(formatResults[0].url, formatResults[0].name);
    return true;
  }

  try {
    const buffers = await Promise.all(
      formatResults.map(async (result) => ({
        name: result.name,
        data: await result.blob.arrayBuffer(),
      }))
    );
    const zipBuffer = await zipFiles(buffers);
    const blob = new Blob([zipBuffer], { type: "application/zip" });
    const url = URL.createObjectURL(blob);
    const format = formats.find((item) => item.mime === mime);
    save(url, `convertcamel-${format?.ext || "images"}.zip`);
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch (err) {
    onError?.(err);
    return false;
  }
};
